import Text from '@ui/text/text/text';
import RegistrationToggle from './components/registration-toggle/registration-toggle';
import styles from './registration-settings.module.css';
import SSORegistrationSettings from './components/sso/sso-registration-settings';
import EmailConfirmationToggle from './components/emails/email-confirmation-toggle';
import RequireConfirmationToggle from './components/emails/require-confirmation-toggle';
import SuppressDuplicatesToggle from './components/emails/suppress-duplicates-toggle';
import TooltipPortal from '@ui/tooltip-portal/tooltip-portal';
import Icon from '@ui/icons/icon';
import { ICONS } from '@ui/icons/types';
import SingleUseRegistrationToggle from './components/emails/single-use-registration-toggle';
import AdvancedRegistrationSettings from './components/advance/advanced-registration-settings';

export default function RegistrationSettings() {
  return (
    <>
      <div className={styles.registrationSettingsSection}>
        <Text tag="h5" className="h5">
          Registration
        </Text>
        <RegistrationToggle />
      </div>
      <div className={styles.registrationSettingsSection}>
        <div className="flex ai-center gap-8">
          <Text tag="h5" className="h5">
            SSO
          </Text>
          <TooltipPortal tooltipContent={<Text>Single Sign-On</Text>}>
            <Icon name={ICONS.INFO_CIRCLE} size={12} color="var(--primitives-mode-1-gray-500)" />
          </TooltipPortal>
        </div>
        <SSORegistrationSettings />
      </div>
      {/*
      TODO: TO come in another ticket 
    
      <div className={styles.registrationSettingsSection}>
        <div>
          <Text tag="h5" className="h5">
            Gating
          </Text>
        </div>
        <Container design="GlobalCont1" borderRadius="12px" padding="16px">
          Audience List
        </Container>
        <Container design="GlobalCont1" borderRadius="12px" padding="16px">
          Domains
        </Container>
        <Container design="GlobalCont1" borderRadius="12px" padding="16px">
          Passcode
        </Container>
        <Container design="GlobalCont1" borderRadius="12px" padding="16px">
          Custom Error message
        </Container>
      </div> */}
      <div className={styles.registrationSettingsSection}>
        <div className="flex ai-center gap-8">
          <Text tag="h5" className="h5">
            Emails
          </Text>
          <TooltipPortal tooltipContent={<Text>Registraiton Email Settings</Text>}>
            <Icon name={ICONS.INFO_CIRCLE} size={12} color="var(--primitives-mode-1-gray-500)" />
          </TooltipPortal>
        </div>
        <EmailConfirmationToggle />
        <RequireConfirmationToggle />
        <SuppressDuplicatesToggle />
        <SingleUseRegistrationToggle />
      </div>
      <AdvancedRegistrationSettings />
    </>
  );
}
